import { Colors } from 'src/components/theme'
import { rgbaStrOpacity } from 'src/utils/colors'

export type ButtonColorPallete = {
  extraDark: string
  dark: string
  medium: string
  light: string
  extraLight: string
}

const redPallete: ButtonColorPallete = {
  extraDark: Colors.redExtraDark,
  dark: Colors.redDark,
  medium: Colors.redMedium,
  light: Colors.redLight,
  extraLight: Colors.redExtraLight,
}

const bluePallete: ButtonColorPallete = {
  extraDark: Colors.blueDark,
  dark: Colors.blueDark,
  medium: Colors.blueMedium,
  light: Colors.blueLight,
  extraLight: Colors.blueLight,
}

const greenPallete: ButtonColorPallete = {
  extraDark: Colors.bgGreenExtraDark,
  dark: Colors.bgGreenDark,
  medium: Colors.bgGreenMedium,
  light: Colors.bgGreenLight,
  extraLight: Colors.bgGreenExtraLight,
}

const yellowPallete: ButtonColorPallete = {
  extraDark: Colors.yellowDark,
  dark: Colors.yellowMedium,
  medium: Colors.yellowMedium,
  light: Colors.yellowLight,
  extraLight: Colors.yellowLight,
}

const purplePallete: ButtonColorPallete = {
  extraDark: Colors.purpleDark,
  dark: Colors.purpleDark,
  medium: rgbaStrOpacity(Colors.purpleDark, 0.5),
  light: rgbaStrOpacity(Colors.purpleDark, 0.15),
  extraLight: Colors.purpleLight,
}

type ColorOptions = 'inherit' | 'primary' | 'info' | 'success' | 'warning' | 'error' | 'secondary' | 'purple'
export type ColorPallete = Record<ColorOptions, ButtonColorPallete>

export const alphaColorPallete: ColorPallete & {
  purple: ButtonColorPallete
} = {
  inherit: bluePallete,
  primary: bluePallete,
  info: bluePallete,
  success: greenPallete,
  warning: yellowPallete,
  error: redPallete,
  secondary: redPallete,
  purple: purplePallete,
}
